import { createSlice } from "@reduxjs/toolkit";
import { GetFODwellingDetailsFormJson, GetFOSafetySecurityFeaturesFormJson, GetFOUsageAndOccupancyFormJson } from "./FOPolicyChangeActions";

interface IFOPolicyChangeSlice {
  foDwellingDetailsFormFieldsJson: any | null;
  foSafetySecurityFeaturesFormFieldsJson: any | null;
  foUsageAndOccupancyFormFieldsJson: any | null;
}

const initialState: IFOPolicyChangeSlice = {
  foDwellingDetailsFormFieldsJson: null,
  foSafetySecurityFeaturesFormFieldsJson: null,
  foUsageAndOccupancyFormFieldsJson: null,
};

const foPolicyChangeSlice = createSlice({
  name: "foPolicyChange",
  initialState: initialState,
  reducers: {
    setFODwellingDetailsFormFieldsJson: (state, { payload }) => {
      state.foDwellingDetailsFormFieldsJson = payload;
    },
    setFOSafetySecurityFeaturesFormFieldsJson: (state, { payload }) => {
      state.foSafetySecurityFeaturesFormFieldsJson = payload;
    },
    setFOUsageAndOccupancyFormFieldsJson: (state, { payload }) => {
      state.foUsageAndOccupancyFormFieldsJson = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      GetFODwellingDetailsFormJson.fulfilled,
      (state, { payload }) => {
        state.foDwellingDetailsFormFieldsJson =
          payload.status === "SUCCESS" ? payload.data : null;
      }
    );
    builder.addCase(
      GetFOSafetySecurityFeaturesFormJson.fulfilled,
      (state, { payload }) => {
        state.foSafetySecurityFeaturesFormFieldsJson =
          payload.status === "SUCCESS" ? payload.data : null;
      }
    );
    builder.addCase(
      GetFOUsageAndOccupancyFormJson.fulfilled,
      (state, { payload }) => {
        state.foUsageAndOccupancyFormFieldsJson =
          payload.status === "SUCCESS" ? payload.data : null;
      }
    );
  },
});

export default foPolicyChangeSlice.reducer;
export const { setFODwellingDetailsFormFieldsJson, setFOSafetySecurityFeaturesFormFieldsJson, setFOUsageAndOccupancyFormFieldsJson } = foPolicyChangeSlice.actions; 